(function() {
  'use strict';

var ajaxCollapsable = function ($http, $compile) {
    return {
        restrict: "A",
        link: function(scope, element, attrs)
        {
            var ajaxUrl = attrs.ajaxContentUrl;
            var container = attrs.container;
            var ajaxContentLoaded = attrs.ajaxContentLoaded;
            var dataHolder = angular.element(document.getElementById(container + "DataContainer"));


            // Hi Kalpana - as we just discussed - we can make it a little bit more Angular, so
            // you may want to assign two-way binded ngModel by scope{ ngModel: "="} or bindToController {ngModel:"="}
            // and then assign your response.data to ngModel, so it gets available outside of the directive
            // then you can bind it do your element with ng-html-bind="yourModel" on your dataHolder.
            // ps. you may have to inject $sce service and use on ngModel assign ie.
            // scope.ngModel = $sce.trustAsHtml(result.data); instead of scope.ngModel = result.data;


            element.bind('click', function(){
                console.log('ajaxurl'+ajaxUrl);
                console.log('ajaxContentLoaded'+ajaxContentLoaded);
                if(ajaxContentLoaded != true && ajaxContentLoaded != 'true' && ajaxUrl !== undefined && ajaxUrl.length != 0)
                {
                    console.log("making ajax call");
                    $http.get(ajaxUrl).then(
                    function(response){
                        ajaxContentLoaded = true;
                        element.attr('data-ajax-content-loaded', true);
                        dataHolder.html(response.data);
                    });
                }

            });

        }
    };
}

ajaxCollapsable.$inject = ['$http', '$compile'];
angular.module('app').directive('ajaxCollapsable', ajaxCollapsable);

}());